
import { Component } from 'react';
import ErrorAlert from '../Alerts/ErrorAlert';





export default class FormErrors extends Component {
    render() {
        let formErrors = this.props.formErrors;
        if (formErrors.length > 0) {
            <div className='formErrors'>
                {Object.keys(formErrors).map((fieldName, i) => {
                    if (formErrors[fieldName].length > 0) {
                        return (
                            <ErrorAlert message={fieldName} {...formErrors[fieldName]} />
                            // <label key={i}>{fieldName} {formErrors[fieldName]}</p>
                        )
                    } else {
                        return '';
                    }
                })}
            </div>
        }
        else {
            return '';

        }
    }


}